"use client"

import { useEffect, useRef, useState } from "react"
import { OTPInput } from "input-otp"
import { useRouter, useSearchParams } from 'next/navigation'
import { cn } from "@/lib/utils"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { confirmSignIn } from 'aws-amplify/auth';
import { toast } from "sonner"

export function InputOtpLogin({ onClose }) {

  const callbackUrl = useSearchParams().get('callbackUrl');
  const router = useRouter()
  const [value, setValue] = useState("")
  const [hasGuessed, setHasGuessed] = useState(undefined)
  const closeButtonRef = useRef(null)
  const inputRef = useRef(null)

  useEffect(() => {
    if (hasGuessed) {
      closeButtonRef.current?.focus()
    }
  }, [hasGuessed])

  async function onSubmit(e) {
    e?.preventDefault?.();
    inputRef.current?.select()

    try {
      const { isSignedIn, nextStep } = await confirmSignIn({
        challengeResponse: value,
      });

      if (isSignedIn) {
        toast.success("Seja bem-vindo(a)!");
        router.push(callbackUrl ? decodeURIComponent(callbackUrl) : `my/home`);
        return;
      }

      if (nextStep?.signInStep === "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE") {
        toast.error("Código de confirmação incorreto");
      }

    } catch (err) {
      // console.error("InputOtpLogin", err);
      setHasGuessed(false)
      toast.error("Sessão expirada. Faça login novamente")
      onClose();
      return;
    }

    setValue("")
    setTimeout(() => {
      inputRef.current?.blur()
    }, 20)
  }

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <div className="flex flex-col items-center gap-2">
          <DialogHeader>
            <DialogTitle className="sm:text-center">
              Insira o código de confirmação
            </DialogTitle>
            <DialogDescription className="sm:text-center" />
          </DialogHeader>
        </div>

        <div className="space-y-4">
          <div className="flex justify-center">
            <OTPInput
              id="confirmation-code"
              ref={inputRef}
              value={value}
              onChange={(val) => {
                if (val.length <= 6) setValue(val)
              }}
              disabled={value.length >= 6}
              containerClassName="flex items-center gap-3 has-disabled:opacity-50"
              maxLength={6}
              onFocus={() => setHasGuessed(undefined)}
              render={({ slots }) => (
                <div className="flex gap-2">
                  {slots.map((slot, idx) => (
                    <Slot key={idx} {...slot} />
                  ))}
                </div>
              )}
              onComplete={onSubmit}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

function Slot(props) {
  return (
    <div
      className={cn(
        "border-3 border-neutral-500 bg-background text-foreground flex size-9 items-center justify-center rounded-md font-medium shadow-xs transition-[color,box-shadow]",
        { "border-ring ring-ring/50 z-10 ring-[3px]": props.isActive }
      )}
    >
      {props.char !== null && <div>{props.char}</div>}
    </div>
  )
}
